import * as React from 'react';

export default props => {
  return (
    <a
      href="#"
      onClick={() => {
        props.history.length > 2 ? props.history.goBack() : props.history.push('/dashboard');
      }}
    >
      <i className="material-icons">arrow_back</i>
    </a>
  );
};



// WEBPACK FOOTER //
// ./src/my-app/back.tsx